import { useMemo } from 'react'

import { getFilteredDataSource } from './utils'

import type { UseTableSearchFilterParams, UseTableSearchFilterReturn } from './types'

export const useTableSearchFilter = <ColumnsType, DataSourceType extends {}>({
  dataSource,
  tableSearch,
  columnsSearchSchema
}: UseTableSearchFilterParams<ColumnsType, DataSourceType>): UseTableSearchFilterReturn<DataSourceType> => {
  const filteredDataSource = useMemo(
    () =>
      getFilteredDataSource({
        dataSource,
        tableSearch,
        columnsSearchSchema
      }),
    [dataSource, tableSearch]
  )

  return { filteredDataSource }
}
